export default __webpack_public_path__ + "static/media/client-13.144814c4.webp";